import React, { useEffect, useLayoutEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHammer } from "@fortawesome/free-solid-svg-icons";


import { GetLanguage, IsEnglish } from '../../utils/language';
import { formatDate, toDisplayDecimal } from '../../utils';
import { withNamespaces } from 'react-i18next';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Popup from '../controls/Popup'
import MaterialResource from '../materialResource/MaterialResource';
import * as MaterialType from '../../scripts/MaterialResourceTypeMode';

import i18next from 'i18next';
import * as storage from '../../utils/storage';
import styles from '../../styles/timesheet.module.css';
import { isIOS } from '../../utils';

const useStyles = makeStyles({
    table: {
    },
    //appBar: {
    //    top: 'auto',
    //    bottom: 0,
    //    height: '35px!important'
    //},
    appBar: {
        top: 'auto',
        bottom: '56px',
        height: '35px!important',
        boxShadow: '0 9px 20px 0 !important',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    appBarIOS: {
        bottom: '70px',
    },
    total: {
        minHeight: '35px',
    },
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    icons: {
        paddingBottom: '10px!important',
        color: '#3f51b5 !important'
    },
    konekCard: {
        paddingTop: '45px !important'
    }
});

function TimesheetDayDetail(props) {
    const classes = useStyles();
    const { targetDate, onEditTimesheet, data, onLoadComplete } = props;

    const [date, setDate] = React.useState(targetDate);    
    const [dataDetail, setDataDetail] = React.useState(null);
    const [total, setTotal] = React.useState(0);
    const [open, setOpen] = React.useState(false);
    const [timsheetData, setTimsheetData] = React.useState(null);

    const [isUseMaterialResourceTimesheet, setIsUseMaterialResourceTimesheet] = React.useState(storage.getIsUseMaterialResourceTimesheet());
    const [isiOS, setIsiOS] = React.useState(isIOS());

    useEffect(() => {
        loadData();
    }, [data]);

    useLayoutEffect(() => {
        resizeForm();
    }, []);

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const headerElement = document.querySelector('[data-id=headerTimesheetDetail]');

            if (headerElement != null) {
                const header = headerElement.offsetHeight;
                const offSet = 60;

                const customHeight = height - header - offSet;

                const element = document.querySelector('#divDetail');

                if (element != null) {
                    element.style.height = `${customHeight}px`;
                    element.style.overflowX = 'hidden';
                }
            }
        }, 1000);
    }

    const handleClick = (id) => {
        if (data.filter(x => x.timesheetId == id)[0].isCharged == true) {
            // If is already charged we don't allow to edit
            return;
        }

        onEditTimesheet(id);
    }

    const openMaterial = (obj) => {
        onLoadComplete(true);
        setTimsheetData(obj);
        setOpen(true);
    }

    const handleClosePop = () => {
        setOpen(false);
    }

    const loadData = () => {
        let formatData = [];
        let totalDuration = 0;

        data.forEach(item => {
            const startHour = item.startDate !== item.endDate ? formatDate(item.startDate, 'time') : null;
            const endHour = item.startDate !== item.endDate ? formatDate(item.endDate, 'time') : null;
            totalDuration += item.duration;

            formatData.push({
                timesheetId: item.timesheetId,
                startHour: startHour,
                endHour: endHour,
                duration: item.duration,
                payCode: item.sc,
                department: item.department,
                jobTitle: item.jobTitle,
                project: item.project,
                activity: item.activity,
                task: item.task,
                payCodeDescriptionF: item.scFr,
                payCodeDescriptionE: item.scEn,
                jobTitleDescriptionF: item.jobTitleFr,
                jobTitleDescriptionE: item.jobTitleEn,
                departmentDescriptionF: item.departmentFr,
                departmentDescriptionE: item.departmentEn,
                projectDescriptionF: item.projectFr,
                projectDescriptionE: item.projectEn,
                activityDescriptionF: item.activityFr,
                activityDescriptionE: item.activityEn,
                taskDescriptionF: item.taskFr,
                taskDescriptionE: item.taskEn,
                isCCQ: item.isCCQTimesheet,
                jobTitleCCQ: IsEnglish() ? item.jobTitleCCQEn : item.jobTitleCCQFr,
                salaryCCQ: IsEnglish() ? item.salaryCCQEn : item.salaryCCQFr,
                typeCCQPrime: IsEnglish() ? item.typeCCQPrimeEn : item.typeCCQPrimeFr,
                targetDate: date,
                isCharged: item.isCharged
            });
        });
        
        setDataDetail(formatData);
        setTotal(totalDuration);
        onLoadComplete(false);
    }

    return (
        <div id="divDetail">
            <AppBar position="fixed" className={`${classes.appBar} ${isiOS && classes.appBarIOS}`}>
                <Toolbar className={classes.total}>
                    <Typography variant="h6">Total: {toDisplayDecimal(total)}</Typography>
                </Toolbar>
            </AppBar>

            <div className={styles.konekCard + ' ' + classes.konekCard}>
                {dataDetail != null && dataDetail.map((obj, index) =>
                    <React.Fragment key={index}>
                        <div className="listItem">
                            <ListItem button onClick={() => handleClick(obj.timesheetId)}>
                                <ListItemText primary={
                                    (obj.startHour != null ?
                                        `${i18next.t('timesheet:detail-list.from')} ${obj.startHour} ${i18next.t('timesheet:detail-list.to')} ${obj.endHour} (${toDisplayDecimal(obj.duration, 4)})` :
                                        obj.startHour == null && (`${i18next.t('timesheet:detail-list.duration')}${i18next.t('common:labelSeparator')}` + ' ' + toDisplayDecimal(obj.duration, 4)))
                                } secondary={
                                    <React.Fragment>
                                        <span className={styles.listSubtitle1}>
                                            {i18next.t('timesheet:detail-list.payCode') + i18next.t('common:labelSeparator') + ' ' + + obj.payCode + ' - ' + (GetLanguage() == 'fr' ? obj.payCodeDescriptionF : obj.payCodeDescriptionE)}
                                        </span>
                                        <span className={styles.listSubtitle1}>
                                            {i18next.t('timesheet:detail-list.department') + i18next.t('common:labelSeparator') + ' ' + obj.department + ' - ' + (GetLanguage() == 'fr' ? obj.departmentDescriptionF : obj.departmentDescriptionE)}
                                        </span>
                                        <span className={styles.listSubtitle1}>
                                            {i18next.t('timesheet:detail-list.jobTitle') + i18next.t('common:labelSeparator') + ' ' + obj.jobTitle + ' - ' + (GetLanguage() == 'fr' ? obj.jobTitleDescriptionF : obj.jobTitleDescriptionE)}
                                        </span>
                                        {obj.project != null && obj.project != '' ? (
                                            <span className={styles.listSubtitle1}>
                                                {i18next.t('timesheet:detail-list.project') + i18next.t('common:labelSeparator') + ' ' + obj.project + ' - ' + (GetLanguage() == 'fr' ? obj.projectDescriptionF : obj.projectDescriptionE)}
                                            </span>
                                        ) : null}
                                        {obj.activity != null && obj.activity != '' ? (
                                            <span className={styles.listSubtitle1}>
                                                {i18next.t('timesheet:detail-list.activity') + i18next.t('common:labelSeparator') + ' ' + obj.activity + ' - ' + (GetLanguage() == 'fr' ? obj.activityDescriptionF : obj.activityDescriptionE)}
                                            </span>
                                        ) : null}
                                        {obj.projectPay != null && obj.projectPay != '' ? (
                                            <span className={styles.listSubtitle1}>
                                                {i18next.t('timesheet:detail-list.project') + i18next.t('common:labelSeparator') + ' ' + obj.projectPay + ' - ' + (GetLanguage() == 'fr' ? obj.projectDescriptionF : obj.projectDescriptionE)}
                                            </span>
                                        ) : null}
                                        {obj.activityPay != null && obj.activityPay != '' ? (
                                            <span className={styles.listSubtitle1}>
                                                {i18next.t('timesheet:detail-list.activityPay') + i18next.t('common:labelSeparator') + ' ' + obj.activityPay + ' - ' + (GetLanguage() == 'fr' ? obj.projectDescriptionF : obj.projectDescriptionE)}
                                            </span>
                                        ) : null}
                                        {obj.task != null && obj.task != '' ? (
                                            <span className={styles.listSubtitle1}>
                                                {i18next.t('timesheet:detail-list.task') + i18next.t('common:labelSeparator') + ' ' + obj.task + ' - ' + (GetLanguage() == 'fr' ? obj.taskDescriptionF : obj.taskDescriptionE)}
                                            </span>
                                        ) : null}
                                        {obj.isCCQ && obj.jobTitleCCQ &&
                                            <span className={styles.listSubtitle1}>
                                                {i18next.t('timesheet:detail-list.jobTitleCCQ') + i18next.t('common:labelSeparator') + ' ' + obj.jobTitleCCQ}
                                            </span>
                                        }
                                        {obj.isCCQ && obj.salaryCCQ &&
                                            <span className={styles.listSubtitle1}>
                                                {i18next.t('timesheet:detail-list.salaryTable') + i18next.t('common:labelSeparator') + ' ' + obj.salaryCCQ}
                                            </span>
                                        }
                                        {obj.isCCQ && obj.typeCCQPrime &&
                                            <span className={styles.listSubtitle1}>
                                                {i18next.t('timesheet:detail-list.typePrimeCCQ') + i18next.t('common:labelSeparator') + ' ' + obj.typeCCQPrime}
                                            </span>
                                        }
                                    </React.Fragment>
                                    } />
                                {isUseMaterialResourceTimesheet && !obj.isCharged && <ListItemSecondaryAction className={classes.divAction}>
                                    <FontAwesomeIcon icon={faHammer} className={classes.icons} onClick={() => openMaterial(obj)} />
                                </ListItemSecondaryAction>}
                            </ListItem>
                        </div>
                    </React.Fragment>
                )}

                {open && <Popup title={i18next.t('materialResource:form.title')} openPop={open} handleClosePop={handleClosePop}>
                    <MaterialResource timesheetData={timsheetData} typeMode={MaterialType.Type_Timesheet} onLoadComplete={onLoadComplete} />
                </Popup>}
            </div>
        </div>
    );
}

export default withNamespaces(['common', 'materialResource', 'timesheet'], { wait: true })(TimesheetDayDetail);